import { render } from "./TransitonFade.vue?vue&type=template&id=5d2d6d5f"
import script from "./TransitonFade.vue?vue&type=script&lang=js"
export * from "./TransitonFade.vue?vue&type=script&lang=js"
script.render = render

export default script